// import axios
import axios from 'axios';

// Determine API URL based on environment and hostname
const getApiUrl = () => {
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:4000';
  } else {
    return 'https://api.tellmiz.com:4000';
  }
};

export const API_URL = getApiUrl();

// Detect browser name/brand
const getBrowserName = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  
  if (userAgent.includes('chrome') && !userAgent.includes('edg')) {
    return 'chrome';
  } else if (userAgent.includes('firefox')) {
    return 'firefox';
  } else if (userAgent.includes('safari') && !userAgent.includes('chrome')) {
    return 'safari';
  } else if (userAgent.includes('edg')) {
    return 'edge';
  } else if (userAgent.includes('opera') || userAgent.includes('opr')) {
    return 'opera';
  } else if (userAgent.includes('msie') || userAgent.includes('trident')) {
    return 'ie';
  } else {
    return 'unknown';
  }
};

// Create device string similar to mobile app format: "web [browser]"
const device = `web ${getBrowserName()}`;

// create an axios instance
const api = axios.create({
  baseURL: API_URL,
});

let token;

function getTokenFromLocalStorage() {
  // Get access token from localStorage
  token = localStorage.getItem('tellmiz_access_token');
}

api.interceptors.request.use(
  async (config) => {
    // Always get the latest token
    getTokenFromLocalStorage();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    // Add device header with browser information
    config.headers.device = device;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized responses globally
    if (error.response && error.response.status === 401) {
      // Clear the token from localStorage
      localStorage.removeItem('tellmiz_access_token');
      // Navigate to splash screen
      window.location.href = '/';
    }
    return Promise.reject(error);
  },
);

export const GET = async (url, params = {}) => {
  try {
    getTokenFromLocalStorage();

    // console.log('GET: ', {url}, {params});
    const res = await api.get(url, {params});
    // const {categories: _, news: __, ...rest} = res.data;
    // console.log(
    //   'RESPONSE to GET: ',
    //   res.status,
    //   JSON.stringify(res.data, null, 4),
    // );
    return {data: res.data, status: res.status};
  } catch (err) {
    // console.log('ERROR in GET: ', err);
    if (err.response) {
      if (err.response.status === 401) {
      } else if (err.response.status === 500) {
      }
      return {
        error: true,
        status: err.response.status,
        message: err.response.data?.message || 'Check why there is no message',
      };
    } else if (err.request) {
      return {networkError: true};
    } else {
      return {networkError: true, message: 'Request setup error'};
    }
  }
};

export const POST = async (url, params = {}, data = {}) => {
  try {
    const res = await api.post(url, data, {params});
    return {data: res.data, status: res.status};
  } catch (err) {
    return {error: true, status: err?.response?.status, message: err?.response?.data?.message || 'Check why there is no message'};
  }
};

export const PUT = async (url, params = {}, data = {}) => {
  try {
    const res = await api.put(url, data, {params});
    return {data: res.data, status: res.status};
  } catch (err) {
    return {
      error: true,
      status: err?.response?.status,
      message: err?.response?.data?.message || 'Check why there is no message',
    };
  }
};

export const deleteRequest = async ({url, params = {}, data = {}}) => {
  try {
    const res = await api.delete(url, {params, data});
    return {data: res.data, status: res.status};
  } catch (err) {
    return {
      error: true,
      status: err.response.status,
      message: err.response.data?.message || 'Check why there is no message',
    };
  }
};
